// @flow
import {
  abortTiming,
  logCustomTraceEvent,
  stopTiming,
} from 'app/common/lib/TraceLogger/logTraceEvent';

const stopProfileTiming = ({
  isOwnProfile,
  showCreatorProfile,
  gridImagesCached = false,
}: {|
  gridImagesCached?: boolean,
  isOwnProfile: boolean,
  showCreatorProfile?: boolean,
|}) => {
  const metricName = isOwnProfile
    ? PCONST.thrift.TracingClientTypes.PWTAction.OWN_PROFILE
    : PCONST.thrift.TracingClientTypes.PWTAction.OTHER_PROFILE;
  if (showCreatorProfile) {
    abortTiming('creatorProfile', metricName);
  } else {
    if (gridImagesCached) {
      // images are cached and get rendered right away, so we fire VisuallyComplete event immediately.
      logCustomTraceEvent({ name: 'VisuallyComplete', time: Date.now() });
    }
    stopTiming(metricName, { gridImagesCached });
  }
};

export default stopProfileTiming;
